export const NavDrawerWidthExpanded = 200;
export const NavDrawerWidthCollapsed = 60;
export const SettingsDrawerWidth = 360;

// Minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character:
export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?,.&_\-()#^])[A-Za-z\d@$!%*?,.&_\-()#^]{8,}$/;
